// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg:not(:root).svg-icon{overflow:visible}svg:not(:root).svg-icon *{fill:currentColor}.svg-icon{display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-.125em}", ""]);
// Exports
module.exports = exports;
